import { render } from "./Posts.vue?vue&type=template&id=9d9df4ac"
import script from "./Posts.vue?vue&type=script&lang=js"
export * from "./Posts.vue?vue&type=script&lang=js"

import "./Posts.vue?vue&type=style&index=0&id=9d9df4ac&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__